module.exports = __webpack_public_path__ + "img/grafik.16a75250.png";